import { JSXElementConstructor, ReactElement, ReactNode, ReactPortal, useEffect, useState } from "react";
import { ReactI18NextChild } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { CSS, parseHTML } from "src/_utils/styles";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import { ReduxDataKey } from "src/base/store/store";
import { Layout } from "src/base/store/layoutSlice";
import EBSSSModal from "src/base/atoms/EBSSSModal";
import EBSSSTicket from "src/base/atoms/EBSSSTicket";
import { Btn } from "src/AbstractElements";
import FormPage from "../Forms/FormPage";

const FAQPage = () => {
  const { fetchFAQ, faqHelpTopics, appSettings } = useEBSSS();
  const { trans } = useEBSSSLayout();
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [filterFAQ, setFilterFAQ] = useState("");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [creatingTicket, setCreatingTicket] = useState({ type: "", id: null, categoryFormId: null });
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);

  const invertedFormsRelationship = appSettings?.forms
    ?.map((form) => {
      return {
        id: form.parent_category_id,
        category_name: form.parent_category_name,
      };
    })
    ?.reduce((acc, current) => {
      if (!acc.some((item) => item.id === current.id)) {
        acc.push({
          ...current,
          forms: appSettings?.forms?.filter((f) => f.parent_category_id === current.id),
        });
      }
      return acc;
    }, []);

  const toggleModal = () => {
    setModal(!modal);
    let cleanModal = setTimeout(() => {
      setCreatingTicket({ type: "", id: null, categoryFormId: null });
      clearTimeout(cleanModal);
    }, 250);
  };

  useEffect(() => {
    fetchFAQ();
  }, []);

  useEffect(() => {
    if (!modal) {
      fetchFAQ();
    }
  }, [modal]);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.querySelector("#faq-response")?.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;
        if (target.tagName === "A") {
          e.preventDefault();
          let path = target.getAttribute("href");
          console.log(path);
          if (path && (!path.startsWith("#") || path.startsWith("http"))) {
            navigate(process.env.PUBLIC_URL + path);
          }
        }
      });
    }
  }, []);

  return (
    <Page breads={[{ name: trans("website.faq"), active: false, url: "/faq" }]}>
      <Card>
        <CardBody>
          <div className="d-flex flex-column">
            <div className="d-flex flex-row align-items-center justify-content-center">
              <div className="mb-3 col-5" style={CSS({ height: 75 })}>
                <label className="form-label fs-7" htmlFor="query-faq">
                  <i className="fa fa-magnifying-glass text-muted"></i> <small className="text-muted">{trans("website.faq-search")}</small>
                </label>
                <input
                  type="text"
                  className="form-control w-100"
                  id="query-faq"
                  onChange={(e) => {
                    setSelectedArticle(null);
                    setFilterFAQ(e.target.value);
                  }}
                />
              </div>
              <div className="col-1 text-center">{trans("common.or")}</div>
              <div className="mb-3 col-5" style={CSS({ height: 75 })}>
                <label className="form-label fs-7" htmlFor="query-faq">
                  <i className="la la-mail-bulk text-muted"></i> <small className="text-muted">{trans("website.submit-your-request")}</small>
                </label>
                <EBSSSModal
                  hideFooter
                  hideSubmitButton
                  modalSize="modal-lg"
                  modalTitle={trans("website.ticket-create")}
                  modal={modal}
                  toggle={toggleModal}
                  triggerEl={
                    <button onClick={toggleModal} className="w-100 btn btn-outline-info">
                      {trans("website.create-request-now")}
                    </button>
                  }
                >
                  {creatingTicket.type ? (
                    <div>
                      {!creatingTicket?.id ? (
                        <div>
                          <span className="text-muted my-3 fs-6 mb-2">{trans("common.select")}</span>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              console.log("Select: ", e.target.value);
                              setCreatingTicket({ ...creatingTicket, id: e.target.value });
                            }}
                          >
                            <option value={null}>---</option>
                            {creatingTicket?.type !== "form"
                              ? appSettings?.all_types[creatingTicket.type]
                                  ?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                                  ?.map((op) => {
                                    return (
                                      <option value={op.id}>
                                        <span className="text-capitalize">
                                          {trans("website." + creatingTicket?.type?.slice(0, -1)) + " #" + op.id}{" "}
                                          {(creatingTicket?.type === "orders"
                                            ? " | " + op.total + " " + ebsssLayout.commonAppSettings.currency_symbol
                                            : creatingTicket?.type === "reservations"
                                            ? ""
                                            : creatingTicket?.type === "contracts"
                                            ? " | " + op.value + " " + ebsssLayout.commonAppSettings.currency_symbol
                                            : creatingTicket?.type === "projects"
                                            ? " | " + op.name
                                            : creatingTicket?.type === "leads"
                                            ? ""
                                            : " | " + op.total) + " "}
                                          {creatingTicket?.type === "reservations" ? " | " + trans("website.reference") + " " + op.reference : ""}
                                        </span>
                                      </option>
                                    );
                                  })
                              : invertedFormsRelationship
                                  ?.find((i) => i.id === creatingTicket.categoryFormId)
                                  ?.forms?.map((op) => {
                                    return (
                                      <option value={op.slug}>
                                        <span className="text-capitalize">{op?.title}</span>
                                      </option>
                                    );
                                  })}
                          </select>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className={"py-3"}>{creatingTicket.id ? <FormPage formSlug={creatingTicket.id} /> : <></>}</div>
                    </div>
                  ) : (
                    <div className="d-flex gap-5 flex-column justify-content-center">
                      <div>
                        <div className="d-flex col-12 flex-row flex-wrap justify-content-center">
                          {invertedFormsRelationship?.map((op) => {
                            return (
                              <div className={`text-center`} style={CSS({ marginRight: 5, marginBottom: 5 })}>
                                <Btn
                                  attrBtn={{
                                    onClick: () => {
                                      setCreatingTicket({ ...creatingTicket, type: "form", categoryFormId: op.id });
                                    },
                                    className: "btn btn-info m-auto d-flex gap-2 align-items-center",
                                    style: CSS({ width: "100%" }),
                                    alt: "",
                                  }}
                                >
                                  <i className="la la-plus-circle fs-5"> </i> <span>{op.category_name ?? trans("website.forms")}</span>
                                </Btn>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </EBSSSModal>
              </div>
            </div>
            <div className="d-flex flex-md-row flex-column mt-5">
              <div className="col-12 col-md-6">
                <div className="d-flex flex-column">
                  <div
                    className="d-flex flex-column gap-3"
                    style={CSS({
                      maxHeight: 600,
                      overflowX: "hidden",
                      overflowY: "auto",
                    })}
                  >
                    {faqHelpTopics?.help_topics?.map(
                      (ht: {
                        title:
                          | string
                          | number
                          | boolean
                          | ReactElement<any, string | JSXElementConstructor<any>>
                          | Iterable<ReactNode>
                          | ReactPortal
                          | Iterable<ReactI18NextChild>;
                        articles: any[];
                      }) => {
                        return (
                          <div className="shadow-sm">
                            <h4 className="text-muted lead">{ht.title}</h4>
                            <div className="d-flex flex-column ">
                              {ht?.articles
                                ?.filter((hta) => {
                                  return hta?.title?.toLowerCase()?.includes(filterFAQ?.toLowerCase());
                                })
                                ?.map((article) => {
                                  let dscHtml = new DOMParser().parseFromString(article.description, "text/html").documentElement;

                                  dscHtml.querySelectorAll("ol")?.forEach((o) => {
                                    o.style.display = "flex";
                                    o.style.flexDirection = "column";
                                  });

                                  return (
                                    <h5
                                      style={CSS({
                                        cursor: "pointer",
                                        color: article.slug === selectedArticle?.slug ? "#6362E7" : "",
                                      })}
                                      className={`ms-2 p-2 text-muted`}
                                      onClick={() => {
                                        setSelectedArticle({
                                          slug: article.slug,
                                          html: dscHtml.outerHTML,
                                        });
                                        document?.getElementById("faq-content")?.scrollIntoView({
                                          behavior: "smooth",
                                        });
                                      }}
                                    >
                                      {article.title}
                                    </h5>
                                  );
                                })}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 p-3">
                <div className="d-flex flex-column" id="faq-content">
                  {/* <div className="mb-3" style={CSS({ height: 75 })}></div> */}
                </div>
                <h4 className="text-muted" style={CSS({ fontWeight: 300 })}>
                  {trans("website.faq_answer")}:
                </h4>
                <Card className="text-muted" id="faq-response">
                  <CardBody dangerouslySetInnerHTML={{ __html: selectedArticle?.html }}></CardBody>
                </Card>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Page>
  );
};

export default FAQPage;
